import { isLightColor } from './isLightColor';

export const getMode = (bgColor: string): 'light' | 'dark' =>
    bgColor && isLightColor(bgColor) ? 'light' : 'dark';
